import { XHRBackend } from '@angular/http';
import { Router } from '@angular/router';

import { RefreshTokenService } from '../authentication/refresh-token.service';
import { AuthOptions } from './auth.options';
import { HttpService } from './http.service';
import { PendingService } from './pending.service';

export function httpServiceFactory(
  backend: XHRBackend,
  options: AuthOptions,
  router: Router,
  refreshTokenService: RefreshTokenService,
  pendingService: PendingService
) {
  return new HttpService(backend, options, router, refreshTokenService, pendingService);
}



// WEBPACK FOOTER //
// /var/www/lantago-app/lantago-app-demo/src/app/core/services/base/http-service.factory.ts